import { AlternativePageTemplate } from '@/components/AlternativePageTemplate';
import { getI18nProps } from '@/utils/i18n';

export default function AlternativePage() {
    return <AlternativePageTemplate competitorName="Glew" />;
}

export const getStaticProps = getI18nProps;
